<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          v-decorator="['organizationCode']"
          :allow-clear="false"
          :default-active-first-option="defaultSelect"
          slot="organizationCode"
          :value.sync="queryParams.organizationCode"
          selectType="select"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
        <global-select
          slot="wipEntityNameList"
          :value.sync="queryParams.wipEntityNameList"
          selectType="selectMultipleSearch"
          requestApi="/inv/invHandoverMonitorDetail/wipEntityNameComboBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="wipEntityName"
        />
        <global-select
          slot="orderNoList"
          :value.sync="queryParams.orderNoList"
          selectType="selectMultipleSearch"
          requestApi="/inv/invHandoverMonitorDetail/orderNoComboBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="orderNo"
        />
        <a-select slot="incomingVariance" v-model="queryParams.incomingVariance" allowClear>
          <a-select-option :value="'ltZero'">小于0</a-select-option>
          <a-select-option :value="'eqZero'">等于0</a-select-option>
          <a-select-option :value="'gtZero'">大于0</a-select-option>
        </a-select>
        <a-select slot="deliveringVariance" v-model="queryParams.deliveringVariance" allowClear>
          <a-select-option :value="'ltZero'">小于0</a-select-option>
          <a-select-option :value="'eqZero'">等于0</a-select-option>
          <a-select-option :value="'gtZero'">大于0</a-select-option>
        </a-select>
        <a-select slot="receivingVariance" v-model="queryParams.receivingVariance" allowClear>
          <a-select-option :value="'ltZero'">小于0</a-select-option>
          <a-select-option :value="'eqZero'">等于0</a-select-option>
          <a-select-option :value="'gtZero'">大于0</a-select-option>
        </a-select>
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiInvHandoverMonitorDetailExport" ref="download" />
        <a-button
          type="primary"
          @click="handleExport"
        >导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table ref="dataTable" :columns="columns" :tableProps="tableProps" rowKey="id"
                      :scroll="{ fixScreen: true, x: 1000 }">
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import cacheSearch from '@/mixins/cacheSearch'
import { mapState } from 'vuex'
import moment from 'moment'
import { apiGetInvHandoverMonitorDetailPage, apiInvHandoverMonitorDetailExport } from '@/api/report/Handover-monitoring'

export default {
  name: 'HandoverMonitoring',
  components: { DownloadModal },
  mixins: [cacheSearch],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  data() {
    return {
      apiInvHandoverMonitorDetailExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetInvHandoverMonitorDetailPage, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        receivingVariance: undefined,
        deliveringVariance: undefined,
        incomingVariance: undefined,
        wipEntityNameList: undefined,
        orderNoList: undefined,
        firstOutgoingDate: undefined,
        firstOutgoingDateStart: undefined,
        firstOutgoingDateEnd: undefined,
        firstIncomingDate: undefined,
        firstIncomingDateStart: undefined,
        firstIncomingDateEnd: undefined
      },
      formList: [
        { label: '库存组织', decorator: ['organizationCode'], type: 'organizationCode' },
        { label: '工单号', decorator: ['wipEntityNameList'], type: 'wipEntityNameList' },
        {
          label: '首次出库时间',
          type: 'range',
          decorator: ['firstOutgoingDate'],
          disposeFormat: {
            firstOutgoingDateStart: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            firstOutgoingDateEnd: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        {
          label: '首次入库时间',
          type: 'range',
          decorator: ['firstIncomingDate'],
          disposeFormat: {
            firstIncomingDateStart: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            firstIncomingDateEnd: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        { label: '计划单号', decorator: ['orderNoList'], type: 'orderNoList' },
        { label: '入库差异', decorator: ['incomingVariance'], type: 'incomingVariance' },
        { label: '出库差异', decorator: ['deliveringVariance'], type: 'deliveringVariance' },
        { label: '收货差异', decorator: ['receivingVariance'], type: 'receivingVariance' }
      ],
      // 表格字段
      columns: [
        { title: '工厂', dataIndex: 'desOrganizationName', align: 'center', width: 160 },
        { title: '工单号', dataIndex: 'wipEntityName', align: 'center', width: 150 },
        { title: '计划号', dataIndex: 'orderNo', align: 'center', width: 120 },
        { title: '工单状态', dataIndex: 'statusName', align: 'center', width: 80 },
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 160 },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 180 },
        { title: '规格描述', dataIndex: 'specification', align: 'center', width: 180, ellipsis: true },
        { title: '计划数量', dataIndex: 'planQuantity', align: 'center', width: 80 },
        { title: '入库数', dataIndex: 'receivedQuantity', align: 'center', width: 80 },
        { title: '入库差异数', dataIndex: 'incomingVariance', align: 'center', width: 90 },
        { title: '首次出库时间', dataIndex: 'firstOutgoingDate', align: 'center', width: 120 },
        { title: '总出库数量', dataIndex: 'deliveredQuantity', align: 'center', width: 90 },
        { title: '出库差异数', dataIndex: 'deliveringVariance', align: 'center', width: 90 },
        { title: '首次入库时间', dataIndex: 'firstIncomingDate', align: 'center', width: 120 },
        { title: '收货数', dataIndex: 'receivingQty', align: 'center', width: 80 },
        { title: '入库-收货', dataIndex: 'variance', align: 'center', width: 90 },
        { title: '收货差异', dataIndex: 'receivingVariance', align: 'center', width: 90 }
      ]
    }
  },
  created() {
    // 处理缓存逻辑
    if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
      // 处理缓存逻辑
      this.getHistoryCache(
        'refSearchForm',
        'organizationCode',
        {
          firstOutgoingDate: ['firstOutgoingDateStart', 'firstOutgoingDateEnd'],
          firstIncomingDate: ['firstIncomingDateStart', 'firstIncomingDateEnd']
        }
      )
      this.$nextTick(() => {
        this.onSearch()
      })
    }else{
      this.$nextTick(() => {
        this.$refs.refSearchForm.form.setFieldsValue({ firstOutgoingDate: [moment(), moment()] })
        this.onSearch(
          {
            firstOutgoingDateStart: moment().format('YYYY-MM-DD 00:00:00'),
            firstOutgoingDateEnd: moment().format('YYYY-MM-DD 23:59:59')
          }
        )
      })
    }
  },
  methods: {
    // 表单搜索
    onSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        organizationCode: undefined,
        receivingVariance: undefined,
        deliveringVariance: undefined,
        incomingVariance: undefined,
        wipEntityNameList: undefined,
        orderNoList: undefined,
        firstOutgoingDate: undefined,
        firstOutgoingDateStart: undefined,
        firstOutgoingDateEnd: undefined,
        firstIncomingDate: undefined,
        firstIncomingDateStart: undefined,
        firstIncomingDateEnd: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
